import React, { useState } from 'react';
import ReactDOM from "react-dom";
import JobQuoteCreateEditPage from "../JobQuoteCreateEditPage";
import JobQuoteDataTable from "../../datatables/JobQuoteDataTable";
import JobQuoteConvertPage from "../JobQuoteConvertPage";

export const QUOTE_PAGES = {
    INDEX:      'index',
    CREATE:     'create',
    EDIT:       'edit',
    CONVERT:    'convert',
}

const JobQuotePage = (props) => {
    const {
        jobId       = null,
        quoteId     = null,
        page        = QUOTE_PAGES.INDEX,
        parentId    = "",
    } = props;

    const [currentPage, setCurrentPage]             = useState(page);
    const [selectedJobQuote, setSelectedJobQuote]   = useState(!!quoteId ? {id: quoteId} : null);

    const handleChangePage = (page, quote) => {
        switch (page) {
            case QUOTE_PAGES.INDEX:
                window.history.pushState({}, '', route('job.quote.index', {job: jobId}).toString());
                break;
            case QUOTE_PAGES.CREATE:
                window.history.pushState({}, '', route('job.quote.create', {job: jobId}).toString());
                break;
            case QUOTE_PAGES.EDIT:
                window.history.pushState({}, '', route('job.quote.edit', {job: jobId, quote: quote.id}).toString());
                break;
            case QUOTE_PAGES.CONVERT:
                window.history.pushState({}, '', route('job.quote.convert', {job: jobId, quote: quote.id}).toString());
                break;
        }

        setCurrentPage(page);
        setSelectedJobQuote(quote);
    }

    switch (currentPage) {
        case QUOTE_PAGES.CONVERT:
            return (
                <JobQuoteConvertPage
                    jobId={jobId}
                    quoteId={!!selectedJobQuote && !!selectedJobQuote.id ? selectedJobQuote.id : null}
                    onChangePage={(page, quote) => handleChangePage(page, quote)}
                    parentId={parentId}
                />
            );
        case QUOTE_PAGES.EDIT:
            return (
                <JobQuoteCreateEditPage
                    jobId={jobId}
                    quoteId={!!selectedJobQuote && !!selectedJobQuote.id ? selectedJobQuote.id : null}
                    onChangePage={(page, quote) => handleChangePage(page, quote)}
                    parentId={parentId}
                />
            );
        case QUOTE_PAGES.CREATE:
            return (
                <JobQuoteCreateEditPage
                    jobId={jobId}
                    quoteId={null}
                    onChangePage={(page, quote) => handleChangePage(page, quote)}
                    parentId={parentId}
                />
            );
        case QUOTE_PAGES.INDEX:
        default:
            return (
                <JobQuoteDataTable
                    jobId={jobId}
                    onChangePage={(page, quote) => handleChangePage(page, quote)}
                    parentId={parentId}
                />
            )
    }
}

export default JobQuotePage;

const target = document.getElementById('job-quote-page');
if (target) {
    const {
        jobId       = null,
        quoteId     = null,
        page        = QUOTE_PAGES.INDEX,
        parentId    = 'job-quote-page'
    } = target.dataset;

    ReactDOM.render(
        <JobQuotePage
            jobId={jobId}
            quoteId={!!quoteId ? quoteId : null}
            page={page}
            parentId={parentId}
        />
    , target);
}

